import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, tap, withLatestFrom } from 'rxjs';

import { SKIP_HANDLING } from 'src/app/services/api-error';
import { MaybeNull } from 'src/app/utils';
import { OperationInfo } from '../../long-operations/long-operations.interface';
import { OperationInfoService } from '../../long-operations/operation-info.service';
import { INTERCEPTOR_CONFIG } from '../tokens';

@Injectable({ providedIn: 'root' })
export class LongOperationsInterceptor implements HttpInterceptor {
  private readonly operations: Map<string, OperationInfo> = new Map();

  private config = inject(INTERCEPTOR_CONFIG);
  private operationService = inject(OperationInfoService);

  public intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (!req.url.includes(this.config.apiUrl) || req.context?.get(SKIP_HANDLING)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      withLatestFrom(this.operationService.operationScheduled$),
      tap({
        next: ([event, operation]: [HttpEvent<T>, MaybeNull<OperationInfo>]) => {
          if (event.type === HttpEventType.Sent && operation) {
            this.operations.set(req.url, operation);
          }

          if (event.type === HttpEventType.Response) {
            if (!event.url) {
              console.error('No URL provided');
              return;
            }

            const _operation = this.operations.get(event.url);

            if (_operation) {
              this.operationService.showSuccessfulMessage(_operation);
              this.operationService.nullifyOperation(_operation);

              this.operations.delete(event.url);
            }
          }
        },

        error: (error: HttpErrorResponse) => {
          if (!error.url) {
            console.error('No URL provided');
            return;
          }

          const operation = this.operations.get(error.url);

          if (operation) {
            this.operationService.nullifyOperation(operation);
            this.operations.delete(error.url);
          }
        },
      }),

      map(([event, _]: [HttpEvent<T>, MaybeNull<OperationInfo>]) => event),
    );
  }
}
